<div class=" bg-col-51">
    <div class="wrap p-l-4-m p-l-4-s p-r-4-m p-r-4-s"
         [ngClass]="component.alignment === 'center' ? 'p-t-10-m p-t-10-s' : 'p-a-10'">
        <div [ngClass]="firstColumnClass">
            <ng-container *ifSize="'XL'">
                <div class="c-2"
                     *ngIf="component.alignment === 'center'"></div>
            </ng-container>
            <text [variant]="component.textComponentVariat || 'default'"
                  class="w-12-m w-12-s"
                  [ngClass]="component.alignment === 'center' && 'c-8 m-b-0 c-12-m c-12-s'"
                  [content]="component"></text>
        </div>
        <div [ngClass]="secondColumnClass">
            <ng-container *ifSize="'XL'">
                <div class="c-3"
                     *ngIf="component.alignment === 'center'"></div>
            </ng-container>
            <div [ngClass]="component.alignment === 'center' ? 'c-6 c-12-m c-12-s' : 'w-12'">
                @for (item of component.questions; track item; let index = $index) {
                <div class="b-b b-col-6">
                    <span (click)="toggleService.toggle([this.toggleGroupId, index])"
                          class="flex flex-middle flex-justify-between p-a-5 cursor-pointer">
                        <p class="s1"
                           *iCms="'question' of item"></p>
                        <i [toggleClass]="'!icon-chevron-down icon-chevron-up'"
                           [toggleClassBy]="toggleService.getState([toggleGroupId,index])"
                           class="icon-medium"
                           style="font-size: 1.3rem;">
                        </i>
                    </span>
                    @if (item.answer) {
                    <hide-up [open]="[toggleGroupId, index]">
                        <p class="p-a-5 p-t-0 p1 col-11"
                           *iCms="'answer' of item"></p>
                    </hide-up>
                    }
                </div>
                }
            </div>
        </div>
    </div>
</div>
